import styled from 'styled-components';

const Wrapper = styled.section`
    .main {
        height: 600px;
    }
    
    img {
        width: 100%;
        display: block;
        border-radius: var(--radius);
        object-fit: cover;
    }
    .gallery {
        margin-top: 1rem;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        column-gap: 1rem;
        img {
            height: 100px;
            cursor: pointer;
        }
    }
    .active {
        border: 2px solid var(--clr-primary-5);
        opacity: 0.8;
    }
    @media (max-width: 576px) {
        .main {
            height: 300px;
        }
        .gallery {
            img {
                height: 50px;
            }
        }
    }
    @media (min-width: 992px) {
        .main {
            height: 500px;
        }
        .gallery {
            img {
                height: 75px;
            }
        }
    }
`;

export default Wrapper;
